<div class="bl-margin-top--16">
  <div *ngFor="let service of mainService; let i = index;">
    <div class="bl-font-color--base bl-margin-top--16 bl-padding--24 bl-bg-color--snow">
      <ng-container *ngIf="service.isIncluded; else optionalTemplate">
        <div class="bl-font-size--18 ecp-workflow-max-width--450">
          <i class="cu-check-circle-solid bl-font-color--success bl-align-self--center"></i>
          <span class="bl-margin-left--8">
            {{service.relatedProductName}}
          </span>
        </div>
      </ng-container>
      <ng-template #optionalTemplate>
        <div class="bl-check-wrap dx-inValid-share ecp-workflow-max-width--450">
          <input type="checkbox" [(ngModel)]="service.isSelected" name="{{service.relatedProductName}}-accounts-{{i}}"
            id="{{service.relatedProductName}}-accounts-{{i}}"
            [attr.data-automation-id]="'primary-other-member-services-'+isCreditOrDebit(service.relatedProductName)"
            class="bl-display--inline-block"
            (change)="updateSelection(service)">
          <label for="{{service.relatedProductName}}-accounts-{{i}}"
            class="bl-font-color--black bl-font-weight--800 bl-font-size--18">
            {{service.relatedProductName}}
          </label>
        </div>
      </ng-template>

      <div class="bl-font-color--black bl-font-size--16 bl-margin-top--8" *ngIf="service.description"
        [innerHtml]="service.description|safe:'html'"></div>
      <div class="bl-padding-left--16"
        *ngIf="service.availableForJointOwner && service.isSelected && service.availableForJointOwner && hasCoApplicant() && hasCoApplicantServices(i)">
        <div class="bl-margin-top--16 bl-margin-bottom--8 bl-font-weight--800 bl-font-color--steel">
          {{'oaoCheckingSavingAccounts/CoAppServices'|dictionary}}</div>
        <div *ngFor="let service of coAppServices; let z = index;">
          <div
            class="bl-check-wrap dx-inValid-share ecp-workflow-max-width--450"
            [class.bl-margin-bottom--16]="z < coAppServices.length-1">
            <input type="checkbox" name="{{service.membershipServices[i].relatedProductId}}-service-{{z}}"
              id="{{service.membershipServices[i].relatedProductId}}-service-{{z}}"
              [attr.data-automation-id]="'co-app-other-member-services'" 
              class="bl-display--inline-block"
              [(ngModel)]="service.membershipServices[i].isSelected" [disabled]="isYouthMembership()"
              (change)="coAppMembershipServiceSelection(service.bundlePath, service.membershipServices[i].bundleIndex,service.membershipServices[i].isSelected)">
            <label for="{{service.membershipServices[i].relatedProductId}}-service-{{z}}"
              class="bl-font-color--black  bl-font-size--16">
              {{service.firstName | titlecase}} {{service.lastName | titlecase}}
            </label>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>